import YearAccumulateListComponent from "../components/YearAccumulateList";
import useYearAccumulateList from "../hooks/useYearAccumulateList";

const YearAccumulateList = () => {
  const accumulateListProps = useYearAccumulateList();
  return <YearAccumulateListComponent {...accumulateListProps} />;
};

export default YearAccumulateList;
